// Created by hejikun on 2017/11/2 0002.
let special = [
  {
    path: '/special-h',
    name: '特色中医',
    component: () => import('@/pages/special/index')
  },
  {
    path: '/special',
    name: '特色中医',
    // component: () => import('@/pages/special/h-index')
    component: () => import('@/pages/special/h_index_new')

  },
  // {
  //   path: '/special/find',
  //   name: '中医大全',
  //   component: () => import('@/pages/special/find')
  // },
  {
    path: '/special/find_new',
    name: '中医大全',
    component: () => import('@/pages/special/find_new')
  },
  // {
  //   path: '/special/doc_list',
  //   name: '知名中医',
  //   component: () => import('@/pages/special/doc_list')
  // },
  {
    path: '/special/doc_list',
    name: '知名中医',
    component: () => import('@/pages/special/doc_list_new')
  },
  // {
  //   path: '/special/hos_list',
  //   name: '医院列表',
  //   component: () => import('@/pages/special/hos_list')
  // },
  {
    path: '/special/hos_list_new',
    name: '医院列表',
    component: () => import('@/pages/special/hos_list_new')
  },
  // {
  //   path: '/special_famous_doctors',
  //   name: '省级名中医',
  //   component: () => import('@/pages/special/famous_doctors')
  // },
  {
    path: '/special_famous_doctors_new',
    name: '省级名中医',
    component: () => import('@/pages/special/famous_doctors_new')
  },
  {
    path: '/special_famous_register',
    name: '省级名中医',
    component: () => import('@/pages/special/special_famous_register')
  }
]

export default special
